import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const glasswareCategories = [
  { id: 'all', label: 'All Glassware' },
  { id: 'glass', label: 'Glassware' },
  { id: 'acrylic', label: 'Acrylic' },
];

const glasswareItems = [
  // GLASSWARE
  {
    id: 'wine',
    name: 'Wine Glasses',
    category: 'glass',
    pricePerUnit: 1.20,
    description: 'Elegant stemmed wine glasses, perfect for red and white wine service at any event.',
    image: 'https://public.readdy.ai/ai/img_res/9be481b0d365d98fe61fae814b67a25b.jpg',
    icon: 'ri-goblet-line',
    popular: true,
  },
  {
    id: 'flutes',
    name: 'Champagne Flutes',
    category: 'glass',
    pricePerUnit: 1.20,
    description: 'Tall slender champagne flutes for sparkling wine, prosecco, and celebratory toasts.',
    image: 'https://readdy.ai/api/search-image?query=single%20elegant%20champagne%20flute%20glass%20tall%20and%20slender%20on%20clean%20white%20background%2C%20premium%20event%20glassware%20rental%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20simple%20minimalist%20composition&width=400&height=400&seq=glass-flute-real-001&orientation=squarish',
    icon: 'ri-goblet-line',
    popular: true,
  },
  {
    id: 'hiball',
    name: 'Hiball Glasses',
    category: 'glass',
    pricePerUnit: 1.20,
    description: 'Tall straight-sided hiball glasses ideal for long drinks, cocktails, and mixed beverages.',
    image: 'https://readdy.ai/api/search-image?query=single%20clear%20tall%20highball%20hiball%20drinking%20glass%20on%20clean%20white%20background%2C%20premium%20event%20glassware%20rental%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20simple%20minimalist%20composition&width=400&height=400&seq=glass-hiball-real-001&orientation=squarish',
    icon: 'ri-cup-line',
    popular: false,
  },
  {
    id: 'beers',
    name: 'Beer Glasses',
    category: 'glass',
    pricePerUnit: 1.20,
    description: 'Classic beer glasses suited for lagers, ales, and craft beer service at events.',
    image: 'https://readdy.ai/api/search-image?query=single%20clear%20beer%20pint%20glass%20on%20clean%20white%20background%2C%20premium%20event%20glassware%20rental%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20simple%20minimalist%20composition&width=400&height=400&seq=glass-beer-real-001&orientation=squarish',
    icon: 'ri-cup-line',
    popular: false,
  },
  {
    id: 'hurricane',
    name: 'Hurricane Glasses',
    category: 'glass',
    pricePerUnit: 1.50,
    description: 'Curvy hurricane glasses perfect for tropical cocktails, piña coladas, and frozen drinks.',
    image: 'https://readdy.ai/api/search-image?query=single%20clear%20hurricane%20cocktail%20glass%20with%20curved%20shape%20on%20clean%20white%20background%2C%20premium%20event%20glassware%20rental%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20tropical%20drink%20glass&width=400&height=400&seq=glass-hurricane-real-001&orientation=squarish',
    icon: 'ri-goblet-fill',
    popular: true,
  },
  {
    id: 'martini',
    name: 'Martini Glasses',
    category: 'glass',
    pricePerUnit: 1.50,
    description: 'Iconic V-shaped martini glasses for classic cocktails, cosmopolitans, and espresso martinis.',
    image: 'https://readdy.ai/api/search-image?query=single%20elegant%20clear%20martini%20cocktail%20glass%20V-shaped%20on%20clean%20white%20background%2C%20premium%20event%20glassware%20rental%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20classic%20bar%20glass&width=400&height=400&seq=glass-martini-real-001&orientation=squarish',
    icon: 'ri-goblet-line',
    popular: true,
  },
  {
    id: 'coupe',
    name: 'Coupe Glasses',
    category: 'glass',
    pricePerUnit: 1.50,
    description: 'Vintage-style coupe glasses for champagne, daiquiris, and elegant cocktail presentations.',
    image: 'https://readdy.ai/api/search-image?query=single%20elegant%20clear%20coupe%20cocktail%20glass%20with%20wide%20shallow%20bowl%20on%20clean%20white%20background%2C%20premium%20event%20glassware%20rental%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20vintage%20style%20glass&width=400&height=400&seq=glass-coupe-real-001&orientation=squarish',
    icon: 'ri-goblet-fill',
    popular: false,
  },
  {
    id: 'tropical',
    name: 'Tropical Glasses',
    category: 'glass',
    pricePerUnit: 1.50,
    description: 'Fun tropical-style glasses for themed events, tiki cocktails, and summer parties.',
    image: 'https://readdy.ai/api/search-image?query=single%20colorful%20tropical%20tiki%20cocktail%20glass%20on%20clean%20white%20background%2C%20fun%20party%20glassware%20for%20events%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20exotic%20drink%20glass&width=400&height=400&seq=glass-tropical-real-001&orientation=squarish',
    icon: 'ri-sun-line',
    popular: false,
  },
  {
    id: 'wings-fruit',
    name: 'Wings Fruit Cocktail',
    category: 'glass',
    pricePerUnit: 2.00,
    description: 'Specialty wings-shaped fruit cocktail glasses for creative presentations and wow-factor drinks.',
    image: 'https://readdy.ai/api/search-image?query=single%20unique%20decorative%20fruit%20cocktail%20glass%20with%20wing%20shaped%20design%20on%20clean%20white%20background%2C%20creative%20event%20glassware%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20specialty%20bar%20glass&width=400&height=400&seq=glass-wings-real-001&orientation=squarish',
    icon: 'ri-leaf-line',
    popular: false,
  },
  {
    id: 'pulsar',
    name: 'Pulsar Cup Glasses',
    category: 'glass',
    pricePerUnit: 1.50,
    description: 'Modern pulsar cup glasses with a textured design, great for cocktails and spirits.',
    image: 'https://readdy.ai/api/search-image?query=single%20modern%20textured%20pulsar%20cup%20drinking%20glass%20on%20clean%20white%20background%2C%20contemporary%20event%20glassware%20rental%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20stylish%20bar%20glass&width=400&height=400&seq=glass-pulsar-real-001&orientation=squarish',
    icon: 'ri-cup-line',
    popular: false,
  },
  // ACRYLIC
  {
    id: 'acrylic-plate',
    name: 'Acrylic Plate Glasses',
    category: 'acrylic',
    pricePerUnit: 3.50,
    description: 'Shatterproof acrylic plate-style glasses, safe and stylish for outdoor events and pool parties.',
    image: 'https://readdy.ai/api/search-image?query=single%20clear%20acrylic%20plate%20style%20flat%20drinking%20glass%20on%20clean%20white%20background%2C%20shatterproof%20plastic%20event%20glassware%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20modern%20unbreakable%20glass&width=400&height=400&seq=acrylic-plate-real-001&orientation=squarish',
    icon: 'ri-shield-check-line',
    popular: false,
  },
  {
    id: 'acrylic-cocktail',
    name: 'Acrylic Cocktail Glasses',
    category: 'acrylic',
    pricePerUnit: 4.00,
    description: 'Premium shatterproof acrylic cocktail glasses, perfect for ladies\' nights and outdoor celebrations.',
    image: 'https://readdy.ai/api/search-image?query=single%20clear%20acrylic%20cocktail%20margarita%20glass%20on%20clean%20white%20background%2C%20shatterproof%20premium%20plastic%20event%20glassware%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20unbreakable%20party%20glass&width=400&height=400&seq=acrylic-cocktail-real-001&orientation=squarish',
    icon: 'ri-shield-check-line',
    popular: true,
  },
  {
    id: 'acrylic-tumbler',
    name: 'Acrylic Tumblers',
    category: 'acrylic',
    pricePerUnit: 3.00,
    description: 'Durable acrylic tumblers for all beverages. Shatterproof, lightweight, and event-safe.',
    image: 'https://readdy.ai/api/search-image?query=single%20clear%20acrylic%20tumbler%20drinking%20glass%20on%20clean%20white%20background%2C%20shatterproof%20premium%20plastic%20highball%20glass%20for%20events%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20unbreakable%20event%20glass&width=400&height=400&seq=acrylic-tumbler-real-001&orientation=squarish',
    icon: 'ri-shield-check-line',
    popular: false,
  },
];

const packageDeals = [
  {
    id: 'pkg-100',
    name: '100 Guest Package',
    guests: 100,
    badge: null,
    items: [
      { glassType: 'Mixed Glassware', qty: 150, pricePerUnit: 1.10, total: 165 },
      { glassType: 'Acrylic Mixed', qty: 120, pricePerUnit: 3.00, total: 360 },
      { glassType: 'Premium Cocktail Mix', qty: 150, pricePerUnit: 1.40, total: 210 },
    ],
    includes: ['Delivery & collection', 'Professional washing', 'Crate & rack storage', 'Breakage buffer 5%'],
  },
  {
    id: 'pkg-200',
    name: '200 Guest Package',
    guests: 200,
    badge: 'Best Value',
    items: [
      { glassType: 'Mixed Glassware', qty: 300, pricePerUnit: 1.00, total: 300 },
      { glassType: 'Acrylic Mixed', qty: 240, pricePerUnit: 2.75, total: 660 },
      { glassType: 'Premium Cocktail Mix', qty: 300, pricePerUnit: 1.25, total: 375 },
    ],
    includes: ['Delivery & collection', 'Professional washing', 'Crate & rack storage', 'Breakage buffer 10%', 'Dedicated setup team'],
  },
];

export default function GlasswarePackages() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedGuests, setSelectedGuests] = useState<number>(100);
  const [expandedItem, setExpandedItem] = useState<string | null>(null);
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation({ rootMargin: '0px 0px -50px 0px' });
  const { ref: packagesRef, isVisible: packagesVisible } = useScrollAnimation({ rootMargin: '0px 0px -50px 0px' });

  const filtered = activeCategory === 'all'
    ? glasswareItems
    : glasswareItems.filter((item) => item.category === activeCategory);

  const activePackage = packageDeals.find((p) => p.guests === selectedGuests)!;

  const scrollToInquiry = () => {
    const el = document.getElementById('inquiry');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="glassware" className="py-32 bg-gradient-to-b from-stone-50 to-white relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-300/40 to-transparent"></div>
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-amber-50/60 rounded-full -translate-x-1/3 blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-[400px] h-[400px] bg-amber-50/40 rounded-full translate-x-1/4 blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative">
        {/* Section Header */}
        <div
          ref={headerRef}
          className={`text-center mb-16 scroll-animate ${headerVisible ? 'visible' : ''}`}
        >
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-amber-400"></div>
            <span className="text-amber-600 text-xs font-semibold tracking-[0.25em] uppercase">
              Glassware Hire
            </span>
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-amber-400"></div>
          </div>
          <h2 className="text-5xl md:text-6xl font-display font-normal text-stone-900 mb-5">
            Glassware{' '}
            <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-amber-500 to-amber-600">
              Collection
            </span>
          </h2>
          <p className="text-stone-500 max-w-2xl mx-auto leading-relaxed">
            Browse our full range of glassware and acrylic options available for hire. All prices are per glass and include delivery, collection, and professional washing.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {glasswareCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat.id
                  ? 'bg-gradient-to-r from-amber-600 to-amber-500 text-white shadow-lg shadow-amber-500/20'
                  : 'bg-stone-100 text-stone-500 hover:text-stone-700 hover:bg-stone-200'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Glassware Grid - Per Item */}
        <div
          ref={gridRef}
          className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 mb-24 stagger-children ${gridVisible ? 'visible' : ''}`}
        >
          {filtered.map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-2xl overflow-hidden border border-stone-100 hover:border-amber-200 hover:shadow-xl transition-all duration-500 relative"
            >
              {/* Popular Badge */}
              {item.popular && (
                <div className="absolute top-3 left-3 z-10 px-2.5 py-1 bg-gradient-to-r from-amber-500 to-amber-400 text-white text-[10px] font-bold rounded-full uppercase tracking-wider">
                  Popular
                </div>
              )}

              {/* Category Badge */}
              <div className="absolute top-3 right-3 z-10">
                <span className={`px-2 py-0.5 text-[10px] font-semibold rounded-full ${
                  item.category === 'acrylic'
                    ? 'bg-amber-50 text-amber-600 border border-amber-200'
                    : 'bg-stone-50 text-stone-500 border border-stone-200'
                }`}>
                  {item.category === 'acrylic' ? 'Acrylic' : 'Glass'}
                </span>
              </div>

              {/* Image */}
              <div className="relative h-40 bg-gradient-to-br from-stone-50 to-stone-100 p-4 flex items-center justify-center">
                <img
                  src={item.image}
                  alt={item.name}
                  title={`${item.name} - event glassware hire Australia`}
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-4">
                <div className="flex items-center gap-1.5 mb-1">
                  <div className="w-6 h-6 rounded-md bg-amber-50 flex items-center justify-center">
                    <i className={`${item.icon} text-amber-600 text-xs`}></i>
                  </div>
                  <h3 className="text-sm font-serif font-semibold text-stone-900 leading-tight">{item.name}</h3>
                </div>

                <p className="text-stone-400 text-xs leading-relaxed mb-3 line-clamp-2">{item.description}</p>

                {/* Price */}
                <div className="flex items-end justify-between pt-3 border-t border-stone-100">
                  <div>
                    <span className="text-2xl font-display text-stone-900">${item.pricePerUnit.toFixed(2)}</span>
                    <span className="text-stone-400 text-xs ml-1">/ glass</span>
                  </div>
                  <button
                    onClick={scrollToInquiry}
                    className="w-8 h-8 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center hover:bg-amber-600 hover:text-white transition-all cursor-pointer"
                  >
                    <i className="ri-chat-1-line text-sm"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* PACKAGE DEALS SECTION */}
        <div className="mb-8">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-4 mb-4">
              <div className="w-12 h-px bg-gradient-to-r from-transparent to-amber-400"></div>
              <span className="text-amber-600 text-xs font-semibold tracking-[0.25em] uppercase">
                Save More
              </span>
              <div className="w-12 h-px bg-gradient-to-l from-transparent to-amber-400"></div>
            </div>
            <h3 className="text-3xl md:text-4xl font-display text-stone-900 mb-3">
              Package{' '}
              <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-amber-500">
                Deals
              </span>
            </h3>
            <p className="text-stone-500 max-w-xl mx-auto text-sm">
              Bulk hire packages with discounted per-glass rates. All packages include delivery, collection, and washing.
            </p>
          </div>

          {/* Guest Count Toggle */}
          <div className="flex justify-center mb-10">
            <div className="inline-flex items-center bg-stone-100 rounded-full p-1">
              {packageDeals.map((pkg) => (
                <button
                  key={pkg.id}
                  onClick={() => {
                    setSelectedGuests(pkg.guests);
                    setExpandedItem(null);
                  }}
                  className={`relative px-8 py-3 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                    selectedGuests === pkg.guests
                      ? 'bg-gradient-to-r from-amber-600 to-amber-500 text-white shadow-lg shadow-amber-500/20'
                      : 'text-stone-500 hover:text-stone-700'
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <i className="ri-group-line"></i>
                    <span>{pkg.guests} Guests</span>
                  </div>
                  {pkg.badge && selectedGuests === pkg.guests && (
                    <span className="absolute -top-2 -right-2 px-2 py-0.5 bg-amber-400 text-amber-900 text-[10px] font-bold rounded-full">
                      {pkg.badge}
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Package Cards */}
          <div
            ref={packagesRef}
            className={`grid md:grid-cols-3 gap-6 stagger-children ${packagesVisible ? 'visible' : ''}`}
          >
            {activePackage.items.map((deal, idx) => {
              const isExpanded = expandedItem === deal.glassType;
              const isFeatured = idx === 2;

              return (
                <div
                  key={deal.glassType}
                  className={`relative bg-white rounded-3xl overflow-hidden border transition-all duration-500 hover:shadow-2xl ${
                    isFeatured
                      ? 'border-amber-200 shadow-lg shadow-amber-100/50 ring-1 ring-amber-100'
                      : 'border-stone-100 hover:border-amber-200/50'
                  }`}
                >
                  {isFeatured && (
                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-500 to-amber-400"></div>
                  )}

                  <div className="p-7">
                    <div className="flex items-center gap-3 mb-2">
                      <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                        isFeatured ? 'bg-gradient-to-br from-amber-500 to-amber-400' : 'bg-amber-50'
                      }`}>
                        <i className={`ri-goblet-line text-lg ${isFeatured ? 'text-white' : 'text-amber-600'}`}></i>
                      </div>
                      <div>
                        <h4 className="text-lg font-serif font-semibold text-stone-900">{deal.glassType}</h4>
                        <p className="text-stone-400 text-xs">{deal.qty} pieces for {activePackage.guests} guests</p>
                      </div>
                    </div>

                    {/* Price */}
                    <div className="flex items-end gap-2 mt-5 mb-1">
                      <span className="text-4xl font-display text-stone-900">${deal.total}</span>
                      <span className="text-stone-400 text-sm mb-1">/ package</span>
                    </div>
                    <p className="text-amber-600 text-sm font-medium mb-6">
                      ${deal.pricePerUnit.toFixed(2)} per glass
                    </p>

                    {/* What's Included Toggle */}
                    <button
                      onClick={() => setExpandedItem(isExpanded ? null : deal.glassType)}
                      className="flex items-center justify-between w-full py-3 border-t border-stone-100 text-sm font-medium text-stone-600 hover:text-amber-600 transition-colors cursor-pointer"
                    >
                      <span>What&apos;s included</span>
                      <i className={`ri-arrow-${isExpanded ? 'up' : 'down'}-s-line text-lg transition-transform`}></i>
                    </button>

                    <div
                      className={`overflow-hidden transition-all duration-500 ${
                        isExpanded ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                      }`}
                    >
                      <div className="space-y-2 pb-4">
                        {activePackage.includes.map((inc, i) => (
                          <div key={i} className="flex items-center gap-2 text-sm text-stone-600">
                            <i className="ri-check-line text-amber-500 flex-shrink-0"></i>
                            <span>{inc}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* CTA */}
                    <button
                      onClick={scrollToInquiry}
                      className={`w-full py-3.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 ${
                        isFeatured
                          ? 'bg-gradient-to-r from-amber-600 to-amber-500 text-white hover:from-amber-500 hover:to-amber-400 shadow-lg shadow-amber-500/20'
                          : 'bg-stone-900 text-white hover:bg-amber-700'
                      }`}
                    >
                      <i className="ri-chat-1-line"></i>
                      Book This Package
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Full Price List Table */}
        <div className="mt-20 bg-white rounded-3xl border border-stone-100 overflow-hidden shadow-sm">
          <div className="p-8 border-b border-stone-100">
            <h3 className="text-2xl font-display text-stone-900 text-center">
              Full Price List — Per Glass
            </h3>
            <p className="text-stone-400 text-sm text-center mt-1">
              All prices in AUD &middot; Delivery, collection &amp; washing included
            </p>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-stone-50">
                  <th className="text-left px-6 py-4 text-xs font-semibold text-stone-400 uppercase tracking-wider">
                    Item
                  </th>
                  <th className="text-center px-4 py-4 text-xs font-semibold text-stone-400 uppercase tracking-wider">
                    Type
                  </th>
                  <th className="text-center px-4 py-4 text-xs font-semibold text-stone-400 uppercase tracking-wider">
                    Price / Glass
                  </th>
                  <th className="text-center px-4 py-4 text-xs font-semibold text-stone-400 uppercase tracking-wider">
                    50 Glasses
                  </th>
                  <th className="text-center px-4 py-4 text-xs font-semibold text-stone-400 uppercase tracking-wider">
                    100 Glasses
                  </th>
                  <th className="text-center px-4 py-4 text-xs font-semibold text-stone-400 uppercase tracking-wider">
                    200 Glasses
                  </th>
                  <th className="text-right px-6 py-4 text-xs font-semibold text-stone-400 uppercase tracking-wider">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {glasswareItems.map((item, idx) => (
                  <tr
                    key={item.id}
                    className={`border-t border-stone-50 hover:bg-amber-50/30 transition-colors ${
                      idx % 2 === 0 ? 'bg-white' : 'bg-stone-50/30'
                    }`}
                  >
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-lg bg-stone-100 flex items-center justify-center overflow-hidden flex-shrink-0">
                          <img src={item.image} alt={item.name} className="w-8 h-8 object-contain" />
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-stone-800">{item.name}</p>
                          {item.popular && (
                            <span className="text-[10px] text-amber-600 font-semibold">Popular</span>
                          )}
                        </div>
                      </div>
                    </td>
                    <td className="text-center px-4 py-4">
                      <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${
                        item.category === 'acrylic'
                          ? 'bg-amber-50 text-amber-600'
                          : 'bg-stone-100 text-stone-500'
                      }`}>
                        {item.category === 'acrylic' ? 'Acrylic' : 'Glass'}
                      </span>
                    </td>
                    <td className="text-center px-4 py-4">
                      <span className="text-lg font-display text-stone-900">${item.pricePerUnit.toFixed(2)}</span>
                    </td>
                    <td className="text-center px-4 py-4 text-sm text-stone-600">
                      ${(item.pricePerUnit * 50).toFixed(0)}
                    </td>
                    <td className="text-center px-4 py-4 text-sm text-stone-600">
                      ${(item.pricePerUnit * 100).toFixed(0)}
                    </td>
                    <td className="text-center px-4 py-4 text-sm text-stone-600">
                      ${(item.pricePerUnit * 200).toFixed(0)}
                    </td>
                    <td className="text-right px-6 py-4">
                      <button
                        onClick={scrollToInquiry}
                        className="px-3 py-1.5 text-xs font-medium text-amber-600 bg-amber-50 rounded-full hover:bg-amber-600 hover:text-white transition-all cursor-pointer whitespace-nowrap"
                      >
                        Enquire
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-6 p-8 bg-gradient-to-r from-amber-50 via-amber-50/50 to-amber-50 rounded-2xl border border-amber-100">
            <div className="text-center sm:text-left">
              <p className="text-stone-900 font-display text-xl mb-1">Need a custom order?</p>
              <p className="text-stone-500 text-sm">
                We create bespoke glassware packages for 50 to 500+ guests
              </p>
            </div>
            <button
              onClick={scrollToInquiry}
              className="px-6 py-3 bg-gradient-to-r from-amber-600 to-amber-500 text-white rounded-full hover:from-amber-500 hover:to-amber-400 transition-all whitespace-nowrap flex items-center gap-2 text-sm font-semibold shadow-lg shadow-amber-500/20 cursor-pointer"
            >
              <i className="ri-chat-1-line"></i>
              Get Custom Quote
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
